import { BROWSER_NAMES, OS_NAMES } from "modules/systemCheck/constants";

export const isBrowserName = (name: string): name is BROWSER_NAMES =>
  (name as BROWSER_NAMES) !== undefined;

export const isOsName = (name: string): name is OS_NAMES =>
  (name as OS_NAMES) !== undefined;
